import { loadStripe, Stripe } from '@stripe/stripe-js';

// ====================================================================================
// CLAVES DE PRODUCCIÓN DE STRIPE
// Estas son las claves REALES que conectan la aplicación con tu cuenta de Stripe.
// ====================================================================================
const STRIPE_PUBLISHABLE_KEY = 'pk_live_33cmim5KgPWpFY8Dw5sJRKH500WzX8CshQ';

let stripePromise: Promise<Stripe | null>;

export const getStripe = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    if (!STRIPE_PUBLISHABLE_KEY.startsWith('pk_live_')) {
        console.error("Clave publicable de Stripe no válida o no es de producción. Por favor, revisa services/stripe.ts");
        return Promise.resolve(null);
    }
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

// ====================================================================================
// IDs DE PRECIOS DE PRODUCCIÓN
// Estos son los IDs de los planes de suscripción REALES en tu cuenta de Stripe.
// ====================================================================================
export const STRIPE_PRICE_IDS = {
  monthly: 'price_1SKiXcBz8dSrUCRLtfWp0FFV',
  annual: 'price_1SNAzXBz8dSrUCRLqvv6yFnl',
  biannual: 'price_1SNAzXBz8dSrUCRL0Tm9k8uC',
};